<template>
    <div>
        <button-secondary @click="open">
            <i class="fa fa-ellipsis-v mr-2"></i> Einstellungen
        </button-secondary>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>Bearbeiten</template>

                <input-text v-model="bookableHoursBeforeDay" class="mb-8">
                    Buchung erst x Stunden vor dem Tag möglich
                    <template v-slot:helper>z.B. 0 - Konferenzräume lassen sich nur am gleichen Tag buchen. 24 -
                        Konferenzräume lassen sich einen Tag vorher buchen. Leer lassen um zu deaktivieren.
                    </template>
                </input-text>

                <input-text v-if="group.has_conference_room_time_blocker" v-model="timeBlockerBefore" class="mb-8">
                    Aufbereitung/Reinigung Zeitlicher Blocker Vor der Buchung
                    <template v-slot:helper>z.B. 15 - Für Buchungen wird der Raum 15 Minuten vor der Buchung extra für Aufbereitung/Reinigung blockiert.
                    </template>
                </input-text>

                <input-text v-if="group.has_conference_room_time_blocker" v-model="timeBlockerAfter" class="mb-8">
                    Aufbereitung/Reinigung Zeitlicher Blocker nach der Buchung
                    <template v-slot:helper>z.B. 15 - Für Buchungen wird der Raum 15 Minuten nach der Buchung extra für Aufbereitung/Reinigung blockiert.
                    </template>
                </input-text>

                <loading v-show="loading"></loading>

                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="store">Speichern</button-primary>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "../Modal.vue";
import InputText from "../UI/InputText.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import Loading from "../UI/Loading.vue";
import ButtonSecondary from "../UI/ButtonSecondary.vue";

export default {
    name: "ConferenceRoomsEdit",

    components: {
        ButtonSecondary,
        Loading,
        ButtonPrimary,
        InputText,
        Modal
    },

    data: () => ({
        showModal: false,
        bookableHoursBeforeDay: null,
        timeBlockerBefore: 0,
        timeBlockerAfter: 0,
        loading: false,
    }),

    inject: ['group'],

    methods: {
        open() {
            this.showModal = true;
            this.bookableHoursBeforeDay = this.group.conference_room_config.bookable_hours_before_day;
            this.timeBlockerBefore = this.group.conference_room_config.time_blocker_before;
            this.timeBlockerAfter = this.group.conference_room_config.time_blocker_after;
        },
        store() {
            this.loading = true;
            this.$http.post(`/admin/conference_room_config`, {
                bookable_hours_before_day: this.bookableHoursBeforeDay,
                time_blocker_before: this.timeBlockerBefore,
                time_blocker_after: this.timeBlockerAfter,
            })
                .then(() => {
                    this.$root.$emit('alert', 'Gespeichert.');
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
    },
}
</script>

<style scoped>

</style>
